import React from 'react'
import PropTypes from 'prop-types'
import AuthBackground from './AuthBackground'
import AuthContainer from './AuthContainer'

const AuthWrapper = ({ children, ...props }) => (
  <AuthBackground>
    <AuthContainer {...props}>{children}</AuthContainer>
  </AuthBackground>
)

AuthWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
}

export default AuthWrapper



// WEBPACK FOOTER //
// ./src/components/auth/AuthWrapper.js